<script setup>
import { useRoute } from 'vue-router';
import { useFunctionGetter } from 'dashboard/composables/store';

import WootReports from './components/WootReports.vue';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';

const route = useRoute();
const vipLevel = useFunctionGetter('vipLevels/getVipLevel', route.params.id);
</script>

<template>
  <WootReports
    v-if="vipLevel.id"
    :key="vipLevel.id"
    type="vip"
    getter-key="vipLevels/getVipLevels"
    action-key="vipLevels/get"
    :selected-item="vipLevel"
    :download-button-label="$t('VIP_REPORTS.DOWNLOAD_VIP_REPORTS')"
    :report-title="$t('VIP_REPORTS.HEADER')"
    has-back-button
    :enable-time-filter="true"
  />
  <div v-else class="w-full py-20">
    <Spinner class="mx-auto" />
  </div>
</template>
